<script setup>
import { tokenKindLabel } from "@/shared/utils/format";

defineProps({
  activeLegacyTokens: { type: Array, default: () => [] },
  tokens: { type: Array, default: () => [] },
});

const emit = defineEmits(["revoke"]);

function tokenStatus(item) {
  if (item.revokedAt) return { label: "已撤销", cls: "revoked" };
  if (item.kind === "native_mac") return { label: "有效", cls: "valid" };
  return { label: "已停用", cls: "disabled" };
}

function tokenMeta(item) {
  return [item.prefix, tokenKindLabel(item.kind), item.createdAt?.slice(0, 10)].filter(Boolean).join(" · ");
}
</script>

<template>
  <div class="card">
    <div class="card-head">
      <h2>上传 token</h2>
    </div>
    <div class="card-body">
      <p class="card-note">
        生产上传只接受 mac app 设备配对 token。legacy cli token 已停用；如仍显示有效，可以在这里撤销。
        {{ activeLegacyTokens.length ? ` 当前还有 ${activeLegacyTokens.length} 个 legacy token 未撤销。` : "" }}
      </p>
      <div v-if="tokens.length === 0" class="token-list">
        <div class="token-empty">还没有上传 token。</div>
      </div>
      <div v-else class="token-list">
        <div v-for="item in tokens" :key="item.id" class="token-row" :class="{ revoked: Boolean(item.revokedAt) }">
          <div class="token-info">
            <div class="token-name-line">
              <strong>{{ item.name || item.prefix }}</strong>
              <span class="token-status" :class="tokenStatus(item).cls">{{ tokenStatus(item).label }}</span>
            </div>
            <small>{{ tokenMeta(item) }}</small>
          </div>
          <button v-if="!item.revokedAt" type="button" class="btn-outline" @click="emit('revoke', item.id)">撤销</button>
        </div>
      </div>
    </div>
  </div>
</template>
